import { api } from "@/lib/api";

const d = (r) => r.data;

export const foApi = {
  state: () => api.get("/fleet-owners/state").then(d),
  saveSettings: (p) => api.put("/fleet-owners/settings", p).then(d),
  addVehicle: (p) => api.post("/fleet-owners/vehicles", p).then(d),
  updateVehicle: (id, p) => api.put(`/fleet-owners/vehicles/${id}`, p).then(d),
  removeVehicle: (id) => api.delete(`/fleet-owners/vehicles/${id}`).then(d),
  addDriver: (p) => api.post("/fleet-owners/drivers", p).then(d),
  updateDriver: (id, p) => api.put(`/fleet-owners/drivers/${id}`, p).then(d),
  removeDriver: (id) => api.delete(`/fleet-owners/drivers/${id}`).then(d),
  marketplace: () => api.get("/fleet-owners/marketplace").then(d),
  reserve: (p) => api.post("/fleet-owners/reservations", p).then(d),
  cancel: (id) => api.post(`/fleet-owners/reservations/${id}/cancel`).then(d),
  live: () => api.get("/fleet-owners/live").then(d),
  connect: (p) => api.post("/fleet-owners/connection", p).then(d),
  disconnect: () => api.delete("/fleet-owners/connection").then(d),
  addService: (vehicleId, p) => api.post(`/fleet-owners/vehicles/${vehicleId}/service`, p).then(d),
  removeService: (id) => api.delete(`/fleet-owners/service/${id}`).then(d),
  dismissAlert: (key) => api.post("/fleet-owners/alerts/dismiss", { key }).then(d),
  restoreAlerts: () => api.post("/fleet-owners/alerts/restore").then(d),
  gateProof: () => api.get("/fleet-owners/gate-proof").then(d),
};
